import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import ContactForm from '../components/ContactForm'

export default function Home() {
  const [pageData, setPageData] = useState(null)
  const [loading, setLoading] = useState(true)

  const [currentIndex, setCurrentIndex] = useState(0)
  const [activeIndex, setActiveIndex] = useState(0)
  const [visibleCards, setVisibleCards] = useState(4)

  const projects = [
    {
      id: 2,
      category: "Trægulv",
      title: "Sildeben",
      desc: "Lægning af eksklusivt sildebensparket i eg. Perfekt tilpasset og slebet for en uovertruffen finish.",
      image: "https://assets.auxodev.dk/assets/37f7f16d-7c9c-4f81-b10c-2a08ddb4d637/imgi-12-sillebenparket-2-min-1024x768-640x480-c-49.png"
    },
    {
      id: 3,
      category: "Tagarbejde",
      title: "Udnyttelse af loft",
      desc: "Renovering og udnyttelse af uudnyttet loftrum til beboelse, herunder montering af nye tagvinduer.",
      image: "https://assets.auxodev.dk/assets/37f7f16d-7c9c-4f81-b10c-2a08ddb4d637/imgi-4-udnytelse-af-loft-2-min-1024x768-640x480-c-252.png"
    },
    {
      id: 4,
      category: "Terrasse",
      title: "Terrasse i Mahogni",
      desc: "Opbygning af eksklusiv træterrasse i slidstærkt mahognitræ med skjulte skruer og flot finish.",
      image: "https://assets.auxodev.dk/assets/37f7f16d-7c9c-4f81-b10c-2a08ddb4d637/imgi-4-taresse-i-mahogni-min-1024x768-640x480-c-220.png"
    },
    {
      id: 5,
      category: "Tilbygning",
      title: "Tilbygning i Fredensborg",
      desc: "Opbygning af en moderne træbeklædt tilbygning til eksisterende murstensvilla, der skaber ekstra lys og rum.",
      image: "https://assets.auxodev.dk/assets/37f7f16d-7c9c-4f81-b10c-2a08ddb4d637/imgi-4-tilbygning-1-4-min-1024x768-640x480-c-236.png"
    },
    {
      id: 6,
      category: "Døre & Vinduer",
      title: "Ny dør og beklædning",
      desc: "Udskiftning af yderdør samt montering af ny, vejrbestandig træbeklædning på facade.",
      image: "https://assets.auxodev.dk/assets/37f7f16d-7c9c-4f81-b10c-2a08ddb4d637/imgi-4-ny-doer-og-beklaedning-min-96.png"
    }
  ]

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setVisibleCards(1)
      } else if (window.innerWidth < 1024) {
        setVisibleCards(2)
      } else {
        setVisibleCards(4)
      }
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    const maxIndex = Math.max(0, projects.length - visibleCards)
    if (currentIndex > maxIndex) {
      setCurrentIndex(maxIndex)
    }
  }, [visibleCards, currentIndex])

  const nextSlide = () => {
    const maxIndex = Math.max(0, projects.length - visibleCards)
    if (currentIndex < maxIndex) {
      const nextIdx = currentIndex + 1
      setCurrentIndex(nextIdx)
      setActiveIndex(nextIdx)
    } else {
      setCurrentIndex(0)
      setActiveIndex(0)
    }
  }

  const prevSlide = () => {
    const maxIndex = Math.max(0, projects.length - visibleCards)
    if (currentIndex > 0) {
      const prevIdx = currentIndex - 1
      setCurrentIndex(prevIdx)
      setActiveIndex(prevIdx)
    } else {
      setCurrentIndex(maxIndex)
      setActiveIndex(maxIndex)
    }
  }

  const getTranslation = () => {
    if (visibleCards === 1) {
      return `calc(-${currentIndex} * (100% + 24px))`
    } else if (visibleCards === 2) {
      return `calc(-${currentIndex} * (50% + 12px))`
    } else {
      return `calc(-${currentIndex} * (25% + 6px))`
    }
  }

  useEffect(() => {
    fetch('https://api.dev.auxo.dk/public/content/pages')
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          const homePage = data.find((p) => p.page_slug === 'index')
          if (homePage) {
            setPageData(homePage)
          }
        }
      })
      .catch((err) => console.error('Failed to fetch home page data', err))
      .finally(() => setLoading(false))
  }, [])

  // Fallback metadata if CMS is loading/fails
  const title = pageData?.meta_title || 'Tømrer i København | Tømrerfirmaet Hansen & Mortensen'
  const description = pageData?.meta_description || 'Søger du efter en erfaren tømrer i København? Hos Tømrerfirmaet Hansen og Mortensen Fredensborg udfører vi professionelt tømrerarbejde.'

  const services = [
    {
      title: 'Tagarbejde',
      slug: 'tagarbejde',
      desc: 'Renovering, udskiftning og opsætning af nyt tag i København og Nordsjælland.',
      image: 'https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/37f7f16d-7c9c-4f81-b10c-2a08ddb4d637/imgi-10-nyt-tegltag-2-3-min-1024x768-640x480-c-212.png',
    },
    {
      title: 'Renovering',
      slug: 'renovering',
      desc: 'Alt fra sommerhuse til parcelhuse er blevet renoveret og ombygget efter dine behov.',
      image: 'https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/37f7f16d-7c9c-4f81-b10c-2a08ddb4d637/imgi-20-sorthus-108.png',
    },
    {
      title: 'Tilbygning',
      slug: 'tilbygning',
      desc: 'Vi skræddersyer personlige løsninger til dig, der drømmer om en tilbygning til din bolig.',
      image: 'https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/37f7f16d-7c9c-4f81-b10c-2a08ddb4d637/imgi-7-tilbygning-4-4-min-1024x768-640x480-c-248.png',
    },
    {
      title: 'Nybyg',
      slug: 'nybyg',
      desc: 'Vi laver individuelle løsninger efter dine behov, herunder fritidshuse, udestuer og skure.',
      image: 'https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/37f7f16d-7c9c-4f81-b10c-2a08ddb4d637/imgi-11-pavilion-min-1024x768-640x480-c-45.png',
    },
    {
      title: 'Nyt gulv',
      slug: 'nyt-gulv',
      desc: 'Professionel lægning af nye gulve, herunder sildebensparket, plankegulve og renovering.',
      image: 'https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/37f7f16d-7c9c-4f81-b10c-2a08ddb4d637/imgi-12-sillebenparket-2-min-1024x768-640x480-c-49.png',
    },
    {
      title: 'Vinduer og døre',
      slug: 'vinduer-og-doere',
      desc: 'Udskiftning af vinduer og døre i høj kvalitet, der sikrer store besparelser på varmeregningen.',
      image: 'https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/37f7f16d-7c9c-4f81-b10c-2a08ddb4d637/imgi-7-nye-vinduer-og-doere-min-1024x768-640x480-c-112.png',
    },
  ]

  return (
    <div className="flex flex-col min-h-screen">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content="https://assets.auxodev.dk/assets/37f7f16d-7c9c-4f81-b10c-2a08ddb4d637/imgi-4-bannerimg-1.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://assets.auxodev.dk/assets/37f7f16d-7c9c-4f81-b10c-2a08ddb4d637/imgi-4-bannerimg-1.png" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      {/* Hero Section */}
      <section className="relative h-[80vh] min-h-[550px] w-full bg-neutral-950 flex items-center justify-center overflow-hidden">
        {/* Background Video */}
        <div className="absolute inset-0 z-0">
          <video
            src="https://assets.auxodev.dk/assets/37f7f16d-7c9c-4f81-b10c-2a08ddb4d637/shutterstock-3910477725-1-1-1.mp4"
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-full object-cover opacity-55"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-neutral-950/70 via-transparent to-neutral-950/30" />
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full text-left flex flex-col items-start">
          <h3 
            className="text-red-500 text-xs sm:text-sm font-extrabold uppercase tracking-[0.3em] mb-3"
            style={{ textShadow: '1px 1px 3px rgba(0, 0, 0, 0.8)' }}
          >
            Tømrerfirmaet Hansen og Mortensen Fredensborg
          </h3>
          <h1 
            className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-white uppercase tracking-tight max-w-5xl leading-none"
            style={{ textShadow: '3px 3px 12px rgba(0, 0, 0, 0.95), 1px 1px 3px rgba(0, 0, 0, 0.9)' }}
          >
            Tømrerfirma med <br className="hidden sm:inline" /> over 25 års erfaring
          </h1>
          <div className="w-48 h-[5px] bg-white mt-6 mb-5" style={{ boxShadow: '1px 1px 4px rgba(0,0,0,0.5)' }} />
          <p className="text-sm sm:text-base text-zinc-200 max-w-2xl font-medium leading-relaxed" style={{ textShadow: '1px 1px 4px rgba(0,0,0,0.8)' }}>
            – Kvalitet, ansvarlig og ærlighed
          </p>
        </div>

        {/* Bottom Trust bar */}
        <div className="absolute bottom-0 left-0 w-full bg-neutral-900/90 border-t border-zinc-800 py-4 hidden md:block">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-around text-xs font-bold uppercase tracking-wider text-zinc-400">
            <div className="flex items-center gap-2">
              <i className="fa-solid fa-circle-check text-red-500" />
              Over 25 års erfaring
            </div>
            <div className="flex items-center gap-2">
              <i className="fa-solid fa-circle-check text-red-500" />
              Kvalitet, ansvarlighed &amp; ærlighed
            </div>
            <div className="flex items-center gap-2">
              <i className="fa-solid fa-circle-check text-red-500" />
              AA Kreditværdighed
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid Section */}
      <section id="ydelser" className="py-20 px-4 sm:px-6 lg:px-8 bg-zinc-50 border-y border-zinc-200">
        <div className="max-w-7xl mx-auto">
          <div className="text-center flex flex-col items-center mb-16">
            <span className="text-red-700 text-xs font-extrabold uppercase tracking-widest mb-3">
              Ydelser
            </span>
            <h2 className="text-2xl sm:text-4xl font-black text-neutral-950 uppercase tracking-tight">
              Hvad kan vi hjælpe dig med?
            </h2>
            <div className="w-16 h-1 bg-red-700 mt-4 mb-6" />
            <p className="text-zinc-600 text-sm max-w-xl leading-relaxed">
              Vi udfører alle former for opgaveløsninger fra mindre reparationer to hovedentrepriser i både den private og offentlige sektor.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service) => (
              <Link
                key={service.slug}
                to={`/ydelser/${service.slug}`}
                className="relative group overflow-hidden aspect-[4/3] w-full rounded-none block border border-zinc-200/50"
              >
                {/* Background Image */}
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                
                {/* Full-box Expandable Overlay Banner */}
                <div className="absolute inset-x-0 bottom-0 h-[68px] group-hover:h-full bg-neutral-950/75 group-hover:bg-red-700/95 transition-all duration-300 py-5 px-6 flex flex-col justify-center overflow-hidden">
                  <h3 className="text-white text-lg md:text-xl font-bold uppercase tracking-wider">
                    {service.title}
                  </h3>
                  
                  {/* Hidden on static, revealed on hover */}
                  <div className="max-h-0 opacity-0 group-hover:max-h-[200px] group-hover:opacity-100 transition-all duration-300 overflow-hidden mt-0 group-hover:mt-3 flex flex-col justify-between flex-1">
                    <p className="text-zinc-100 text-xs md:text-sm line-clamp-3 leading-relaxed">
                      {service.desc}
                    </p>
                    <div className="mt-4 flex items-center gap-2 text-white text-xs font-bold uppercase tracking-widest">
                      Læs mere <i className="fa-solid fa-arrow-right text-[10px] group-hover:translate-x-1 transition-transform" />
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Intro Section (Profil) - Industrial Craftsman Split Design */}
      <section className="relative min-h-[550px] bg-neutral-950 text-white flex items-center justify-center py-20 px-6 lg:px-20 overflow-hidden">
        
        {/* Desaturated Background Graphic */}
        <div className="absolute inset-0 z-0">
          <img 
            src="https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=80,format=auto/assets/37f7f16d-7c9c-4f81-b10c-2a08ddb4d637/imgi-13-mand-maaler-trae.png" 
            alt="Tømrerarbejde baggrund" 
            className="w-full h-full object-cover filter grayscale brightness-[0.18] contrast-[1.15]"
          />
        </div>

        {/* Content Container */}
        <div className="relative z-10 w-full max-w-7xl grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-4 items-center">
          
          {/* Left Column: Big Brand Statement */}
          <div className="lg:col-span-5 flex flex-col justify-center text-left lg:text-right space-y-2 lg:pr-8">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-white leading-tight uppercase">
              Hvem er vi?
            </h2>
            <p className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-red-700 tracking-wide uppercase">
              Kvalitet, ansvarlighed og ærlighed
            </p>
          </div>

          {/* Divider Column (Desktop Only) */}
          <div className="hidden lg:flex lg:col-span-1 justify-center items-stretch h-full py-4">
            <div className="w-[2px] bg-red-700 min-h-[380px] rounded-full"></div>
          </div>

          {/* Right Column: Detail Content */}
          <div className="lg:col-span-6 flex flex-col justify-center space-y-6 lg:pl-4">
            
            {/* Headline */}
            <h3 className="text-xl sm:text-2xl font-light leading-snug text-neutral-100 max-w-xl">
              Leder du efter en erfaren tømrer i København? Så er du kommet til det rette sted. Hos Tømrerfirmaet Hansen &amp; Mortensen har vi many års erfaring inden for tømrerfaget.
            </h3>
            
            {/* Content Paragraphs */}
            <div className="space-y-4 text-sm sm:text-base text-zinc-300 font-light leading-relaxed max-w-2xl">
              <p>
                Vi er et tømrerfirma der har eksisteret siden 1997, hvor vi er 3 medejere og holder til i Fredensborg. Vi har over 20 års erfaring inden for branchen og har derfor en masse viden. Vi udfører alt arbejde i både hoved og fagentrepriser og har et stort netværk inden for alle fag.
              </p>
              <p>
                Faglig stolthed og professionelt udført arbejde is vigtigt for os. Efter en udført opgave gør vi alt for at vores kunder er glade og tilfedse.
              </p>
              <p>
                Gennem årene har vi udført many specielle opgaver store som små blandt andet for Haldor Topsøe og Kurhotel Skodsborg.
              </p>
            </div>

            <div className="pt-2">
              <Link
                to="/om-os"
                className="inline-flex items-center gap-2 bg-red-700 hover:bg-red-800 text-white text-xs font-bold uppercase tracking-widest py-3 px-6 transition-colors rounded-none"
              >
                Læs mere om os <i className="fa-solid fa-arrow-right text-[10px]" />
              </Link>
            </div>

          </div>

        </div>
      </section>

      {/* Projects Carousel Section */}
      <section className="py-20 bg-zinc-50 border-b border-zinc-200 overflow-hidden">
        <div className="w-full">
          
          {/* Title Section */}
          <div className="text-center flex flex-col items-center mb-12 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <span className="text-red-700 text-xs font-extrabold uppercase tracking-widest mb-3">
              Projekter
            </span>
            <h2 className="text-2xl sm:text-4xl font-black text-neutral-950 uppercase tracking-tight">
              Se mere om vores udførte projekter her
            </h2>
            <div className="w-16 h-1 bg-red-700 mt-4 mb-6" />
            <p className="text-zinc-600 text-sm max-w-xl leading-relaxed">
              Her kan du se et udpluk af vores mange projekter, hvor vi har leveret tømrerarbejde i højeste kvalitet.
            </p>
          </div>

          {/* Carousel Container Area */}
          <div className="relative px-4 sm:px-12 lg:px-16">
            
            {/* Left Arrow Navigation */}
            <button 
              onClick={prevSlide}
              className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-md hover:bg-zinc-50 cursor-pointer transition-colors border border-zinc-100 text-red-700"
              aria-label="Forrige projekt"
            >
              <i className="fa-solid fa-chevron-left text-sm" />
            </button>

            {/* Right Arrow Navigation */}
            <button 
              onClick={nextSlide}
              className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-md hover:bg-zinc-50 cursor-pointer transition-colors border border-zinc-100 text-red-700"
              aria-label="Næste projekt"
            >
              <i className="fa-solid fa-chevron-right text-sm" />
            </button>

            {/* Carousel Track / Grid */}
            <div className="overflow-hidden py-4">
              <div 
                className="flex gap-6 transition-transform duration-500 ease-out"
                style={{ transform: `translateX(${getTranslation()})` }}
              >
                {projects.map((project, index) => {
                  const isActive = index === activeIndex;
                  return (
                    <div
                      key={project.id}
                      className={`w-full md:w-[calc(50%-12px)] lg:w-[calc(25%-18px)] shrink-0 relative aspect-[4/5] p-8 flex flex-col justify-end overflow-hidden shadow-md rounded-none transition-all duration-700 ease-in-out cursor-pointer group ${
                        isActive ? 'bg-red-700 text-white' : 'bg-neutral-950 text-white'
                      }`}
                      onClick={() => {
                        setActiveIndex(index);
                        const targetCurrent = Math.min(index, projects.length - visibleCards);
                        setCurrentIndex(Math.max(0, targetCurrent));
                      }}
                      onMouseEnter={() => setActiveIndex(index)}
                    >
                      {/* Background Image with smooth transitions */}
                      <div 
                        className={`absolute inset-0 bg-cover bg-center transition-all duration-700 ease-in-out ${
                          isActive 
                            ? 'mix-blend-multiply opacity-25 scale-105' 
                            : 'mix-blend-normal opacity-70 scale-100 group-hover:scale-105 group-hover:opacity-25 group-hover:mix-blend-multiply'
                        }`}
                        style={{ backgroundImage: `url(${project.image})` }}
                      />
                      
                      {/* Dark gradient overlay that fades out when active/red */}
                      <div 
                        className={`absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent transition-opacity duration-700 ease-in-out ${
                          isActive ? 'opacity-0' : 'opacity-100 group-hover:opacity-0'
                        }`}
                      />
                      
                      {/* Content container */}
                      <div className="relative z-10 flex flex-col gap-1 w-full">
                        <span className={`text-xs font-semibold tracking-wider uppercase transition-colors duration-500 ${
                          isActive ? 'text-white/90' : 'text-white/80'
                        }`}>
                          {project.category}
                        </span>
                        
                        <h3 className="text-2xl font-bold font-display leading-tight tracking-wide">
                          {project.title}
                        </h3>
                        
                        {/* Smoothly expanding description & button */}
                        <div 
                          className={`transition-all duration-700 ease-in-out overflow-hidden flex flex-col gap-3 ${
                            isActive 
                              ? 'max-h-[250px] opacity-100 mt-3 translate-y-0' 
                              : 'max-h-0 opacity-0 mt-0 translate-y-4 pointer-events-none'
                          }`}
                        >
                          <p className="text-sm text-white/90 leading-relaxed line-clamp-4">
                            {project.desc}
                          </p>
                          <Link
                            to="/galleri"
                            className="self-start bg-neutral-950 text-white font-body text-xs font-bold tracking-widest uppercase px-5 py-3 transition-colors hover:bg-neutral-900 cursor-pointer rounded-none"
                          >
                            Se galleri
                          </Link>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Pagination Dots Indicator */}
            <div className="flex items-center justify-center gap-2 mt-8">
              {projects.map((_, index) => (
                <button
                  key={index}
                  onClick={() => {
                    setActiveIndex(index);
                    const targetCurrent = Math.min(index, projects.length - visibleCards);
                    setCurrentIndex(Math.max(0, targetCurrent));
                  }}
                  className={`transition-all duration-300 rounded-full cursor-pointer ${
                    activeIndex === index 
                      ? "w-2.5 h-2.5 bg-neutral-950 scale-125" 
                      : "w-1.5 h-1.5 bg-zinc-300 hover:bg-zinc-400"
                  }`}
                  aria-label={`Gå til slide ${index + 1}`}
                />
              ))}
            </div>

          </div>
        </div>
      </section>

      {/* Contact / CTA Section */}
      <section className="relative py-24 px-4 sm:px-6 lg:px-8 bg-zinc-950 overflow-hidden">
        {/* Background Wood Texture with Dark Overlay */}
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-100 pointer-events-none"
          style={{ 
            backgroundImage: `url('https://assets.auxodev.dk/assets/37f7f16d-7c9c-4f81-b10c-2a08ddb4d637/dark-wood-texture.jpg')`,
            filter: 'brightness(0.55) contrast(1.2)'
          }}
        />
        <div className="absolute inset-0 bg-neutral-950/45 pointer-events-none" />



        <div className="relative z-10 max-w-3xl mx-auto">
          <div className="flex justify-center w-full">
            <div className="w-full max-w-xl">
              <ContactForm dark={true} />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
